// Mock data for Tech Bro Digital Marketing Agency

export const services = [
  {
    id: 1,
    title: "Social Media Marketing",
    description: "Amplify your brand presence across all social platforms with targeted campaigns and engaging content.",
    icon: "Share2"
  },
  {
    id: 2,
    title: "Branding & Graphics",
    description: "Create a memorable brand identity with stunning visual designs that resonate with your audience.",
    icon: "Palette"
  },
  {
    id: 3,
    title: "Web Development",
    description: "Build responsive, high-performance websites that drive conversions and deliver exceptional user experiences.",
    icon: "Code"
  },
  {
    id: 4,
    title: "Marketing Strategy Consulting",
    description: "Get expert guidance to develop comprehensive marketing strategies that align with your business goals.",
    icon: "Target"
  },
  {
    id: 5,
    title: "AI Video Creation & Marketing",
    description: "Leverage cutting-edge AI technology to create compelling video content that captivates your audience.",
    icon: "Video"
  },
  {
    id: 6,
    title: "Content & SEO Strategy",
    description: "Rank higher on search engines with optimized content strategies that drive organic traffic.",
    icon: "Search"
  },
  {
    id: 7,
    title: "Social Media Management",
    description: "Let us handle your social presence while you focus on growing your business.",
    icon: "MessageCircle"
  },
  {
    id: 8,
    title: "Content Creation",
    description: "Craft engaging, high-quality content that tells your brand story and connects with customers.",
    icon: "FileText"
  },
  {
    id: 9,
    title: "Paid Advertising",
    description: "Maximize ROI with data-driven paid advertising campaigns across Google, Facebook, and more.",
    icon: "TrendingUp"
  }
];

export const stats = [
  { id: 1, value: 500, label: "Projects Completed", suffix: "+" },
  { id: 2, value: 250, label: "Happy Clients", suffix: "+" },
  { id: 3, value: 98, label: "Success Rate", suffix: "%" },
  { id: 4, value: 6, label: "Cities Covered", suffix: "" }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "E-commerce Growth Campaign",
    category: "Social Media Marketing",
    description: "300% increase in online sales through targeted social media campaigns",
    results: "300% ROI"
  },
  {
    id: 2,
    title: "Brand Identity Redesign",
    category: "Branding & Graphics",
    description: "Complete brand transformation for a leading tech startup",
    results: "50% Brand Recognition"
  },
  {
    id: 3,
    title: "SaaS Platform Development",
    category: "Web Development",
    description: "Custom web application serving 10,000+ daily users",
    results: "10K+ Users"
  },
  {
    id: 4,
    title: "SEO Optimization Project",
    category: "Content & SEO",
    description: "First page rankings for 50+ competitive keywords",
    results: "250% Organic Traffic"
  },
  {
    id: 5,
    title: "AI Video Marketing Campaign",
    category: "AI Video Creation",
    description: "Viral video campaign reaching 5M+ viewers",
    results: "5M+ Views"
  },
  {
    id: 6,
    title: "PPC Campaign Management",
    category: "Paid Advertising",
    description: "Optimized ad spend resulting in 400% ROAS",
    results: "400% ROAS"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "TechStart India",
    role: "CEO",
    content: "Tech Bro transformed our digital presence completely. Their strategic approach and execution are exceptional. Highly recommended!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "Fashion Hub",
    role: "Marketing Director",
    content: "Working with Tech Bro was a game-changer. Our social media engagement increased by 400% in just 3 months!",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "GrowthCo",
    role: "Founder",
    content: "The team's expertise in AI video creation and SEO strategy helped us dominate our niche. Outstanding results!",
    rating: 5
  },
  {
    id: 4,
    name: "Sneha Reddy",
    company: "Urban Lifestyle",
    role: "Brand Manager",
    content: "Tech Bro's branding and creative work exceeded all expectations. They truly understand modern digital marketing.",
    rating: 5
  }
];

export const contactInfo = {
  name: "Jaydip Patel",
  phones: ["9510588393", "9315828917"],
  email: "techbrodigitalmarketing@gmail.com",
  locations: ["Delhi", "Ahmedabad", "Jaipur", "Mumbai", "Gurgaon", "Noida"]
};